import {
    PRICE_POLICIES_GET_USER_ROLES_BEGIN,
    PRICE_POLICIES_GET_USER_ROLES_SUCCESS,
    PRICE_POLICIES_GET_USER_ROLES_FAILURE
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
        case PRICE_POLICIES_GET_USER_ROLES_BEGIN:
            return {
                ...state,
                userRolesPending: true,
                userRolesError: false
            }
        case PRICE_POLICIES_GET_USER_ROLES_SUCCESS:
            return {
                ...state,
                userRolesError: false,
                userRoles: action.data.userRoles
            }
        case PRICE_POLICIES_GET_USER_ROLES_FAILURE:
            return {
                ...state,
                userRolesPending: false,
                userRolesError: action.data.userRolesError
            }
        default:
            return state
    }
}
